import { render, staticRenderFns } from "./participantGroup.vue?vue&type=template&id=2f0f790e&scoped=true"
import script from "./participantGroup.vue?vue&type=script&lang=js"
export * from "./participantGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0f790e",
  null
  
)

export default component.exports